import React from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/solid';

const CookiesPolicy = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-3xl font-bold text-gray-900 mb-6">Cookies Policy</h1>
                <p className="text-gray-600 mb-4">
                    Last Updated: March 12, 2025
                </p>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-2">What Are Cookies?</h2>
                    <p className="text-gray-600">
                        Cookies are small text files stored on your device when you visit our website. They help us enhance your browsing experience, analyze traffic, and provide personalized content.
                    </p>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-2">How We Use Cookies</h2>
                    <ul className="list-disc pl-5 text-gray-600">
                        <li><strong>Essential Cookies:</strong> Necessary for core website functions such as navigation and secure access.</li>
                        <li><strong>Analytics Cookies:</strong> Help us understand user behavior and improve site performance.</li>
                        <li><strong>Preference Cookies:</strong> Store your preferences, such as theme settings and language selection.</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-2">Third-Party Cookies</h2>
                    <p className="text-gray-600">
                        We may use third-party services such as Google Analytics to collect website usage data. These services may place cookies on your device. Learn more in their{' '}
                        <a
                            href="https://policies.google.com/technologies/cookies"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:underline"
                        >
                            Cookie Policy
                            <ArrowTopRightOnSquareIcon className="h-4 w-4 inline ml-1" />
                        </a>.
                    </p>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-2">Managing Cookies</h2>
                    <p className="text-gray-600">
                        You can control or disable cookies through your browser settings. To learn how to manage cookies, visit{' '}
                        <a
                            href="https://www.allaboutcookies.org/manage-cookies/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:underline"
                        >
                            this guide
                            <ArrowTopRightOnSquareIcon className="h-4 w-4 inline ml-1" />
                        </a>.
                    </p>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-2">Changes to This Policy</h2>
                    <p className="text-gray-600">
                        We may update this Cookies Policy periodically to reflect changes in our practices. Any updates will be posted on this page with a revised "Last Updated" date.
                    </p>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-2">Contact Us</h2>
                    <p className="text-gray-600">
                        If you have any questions about our Cookies Policy, please contact us at{' '}
                        <a href="mailto:privacy@synaptopathyDB.com" className="text-blue-600 hover:underline">privacy@synaptopathyDB.org</a>.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default CookiesPolicy;